import { render, staticRenderFns } from "./TaskQuestionCard.vue?vue&type=template&id=2dfd6999&scoped=true&"
import script from "./TaskQuestionCard.vue?vue&type=script&lang=ts&"
export * from "./TaskQuestionCard.vue?vue&type=script&lang=ts&"
import style0 from "./TaskQuestionCard.vue?vue&type=style&index=0&id=2dfd6999&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd6999",
  null
  
)

export default component.exports